import { motion, AnimatePresence } from 'framer-motion';
import { Heart, Zap, Trophy } from 'lucide-react';

const TopSuggestionsLeaderboard = ({ topSuggestions }) => {
  if (topSuggestions.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
      className="mt-8 sm:mt-12"
      data-testid="top-suggestions-section"
    >
      <h3 className="font-heading text-lg sm:text-xl font-bold text-zinc-300 mb-4 flex items-center gap-2">
        <Trophy className="w-5 h-5 text-vent-secondary" />
        Top Suggestions
      </h3>
      <div className="space-y-2">
        {topSuggestions.map((suggestion, idx) => (
          <motion.div
            key={suggestion.id}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: idx * 0.1 }}
            className="glass rounded-xl px-4 py-3 flex items-center gap-3 border border-vent-secondary/10"
            data-testid={`top-suggestion-${idx}`}
          >
            <span className="text-vent-secondary font-heading font-bold text-sm w-6">#{idx + 1}</span>
            <p className="text-zinc-300 text-sm flex-1 truncate">{suggestion.content}</p>
            <div className="flex items-center gap-3 text-xs text-zinc-500 shrink-0">
              <span className="flex items-center gap-1">
                <Heart className="w-3 h-3" /> {suggestion.hearts}
              </span>
              <span className="flex items-center gap-1">
                <Zap className="w-3 h-3" /> {suggestion.lightnings}
              </span>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default TopSuggestionsLeaderboard;
